import { useAppSelector } from '@/redux/hooks';
import { showDemoDataSelectors } from '@/redux/selectors';

import { Stats } from './components/Stats';
import { AllTransfers } from './components/AllTransfers';
import { ThisIsDemoData } from '../../ThisIsDemoData';

const Transfers = () => {
  const isShowDemoData = useAppSelector(showDemoDataSelectors.byCompliance);

  return (
    <>
      {isShowDemoData && <ThisIsDemoData />}
      <Stats />
      <AllTransfers />
    </>
  );
};

export default Transfers;
